import { Smile, Package, Award, Headphones } from "lucide-react";
import type { StoreConfig } from "../../features/config/queries";

// Purely admin-entered figures (Settings → Homepage stats) — never computed
// or guessed here. Each cell renders only when the admin has actually set
// that value, so a partially-filled row doesn't show blank/zero entries.
export function HomeStatsRow({ stats }: { stats: NonNullable<StoreConfig["stats"]> }) {
  const items = [
    { icon: Smile, value: stats.happyCustomers, label: "Happy Customers" },
    { icon: Package, value: stats.ordersDelivered, label: "Orders Delivered" },
    { icon: Award, value: stats.qualityProducts, label: "Quality Products" },
    { icon: Headphones, value: stats.supportAvailability, label: "Customer Support" }
  ].filter((item) => item.value);

  if (items.length === 0) return null;

  return (
    <div className="pt-6 mt-1 border-t border-white/10">
      <div className="flex flex-wrap items-center justify-center sm:justify-between gap-x-10 gap-y-6">
        {items.map(({ icon: Icon, value, label }) => (
          <div key={label} className="flex items-center gap-3.5">
            <span className="h-10 w-10 rounded-full bg-white/[0.04] border border-white/10 flex items-center justify-center shrink-0">
              <Icon size={18} className="text-accent" aria-hidden />
            </span>
            <div>
              <p className="text-xl font-serif text-ink tracking-tight leading-none">{value}</p>
              <p className="text-xs text-ink-muted mt-1">{label}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
